import React , {Component} from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import AllGamesPage from './allgames';


class allGames extends Component{
    // constructor(){
    //     super()
    // }
    render(){
        return(
            <div>
            <AllGamesPage {...this.props}/>
            </div>
        )
    }
}

export const AllGames = PnkConnect(allGames , ''); 